import React, { useContext, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { CompletionsContext, LoadingContext, TypesContext } from "../../App"
import { FormTitleContext } from "../../layout/Vertical/Global";
import { MsalInstanceContext, VariablesContext } from "../../auth/AppProvider";
import { SetTrakingHubspot } from "../../utils/functions/trackingHubspot";

import WelcomeHomePage from "./WelcomeHomePage";
import MyCandidaturesPage from "./MyApplications/MyCandidaturesPage";
import NoFormsAvailablePage from "./NoFormsAvailablePage";
import { useNavigate } from "react-router";



function SectionHomePage({ t }) {
    const navigate = useNavigate()
    const [allcompletions,] =  useContext(CompletionsContext);
    const [, setFormTitle] = useContext(FormTitleContext);
    const [loading, setLoading] = useContext(LoadingContext)
    const variables = useContext(VariablesContext)
    // init state
    const [typesParameters,] = useContext(TypesContext)
    const [myCompletions, setMyCompletion] = useState([]);
    const [newCompletion, setNewCompletion] = useState([]);
    const [type, setType] = useState(null);


    const msalInstance = useContext(MsalInstanceContext);


    useEffect(() => {
        setFormTitle(null);
        SetTrakingHubspot(msalInstance, variables.HSTenantID, variables.ClientName, "Home");
    }, [variables, msalInstance])

    useEffect(() => {
        setType(typesParameters.find(t => t.selected === true));
        if (!typesParameters) {
            navigate("/comingsoon")
        }
    }, [typesParameters])


    useEffect(() => {
        if (allcompletions && allcompletions.length) {
            if (type) {
                var Ocompletions = allcompletions.filter(c => c.objectAssociated)
                setMyCompletion(Ocompletions);
                var Ncompletions = allcompletions.filter(c => !c.objectAssociated)
                setNewCompletion(Ncompletions);
                if (Ocompletions && Ocompletions.length > 0) {
                    navigate("")
                    if (Ncompletions && Ncompletions.length > 0) {
                        setLoading(false);
                    }
                }
            }

        }
    }, [allcompletions, msalInstance, type])

    if (loading) return null;

    // No forms available at all
    if (!allcompletions || allcompletions.length === 0) {
        return <NoFormsAvailablePage />;
    }

    // Candidate has started applications → Screen 2
    if (myCompletions && myCompletions.length > 0) {
        const canCreate = newCompletion && newCompletion.length > 0 && type?.canCreateNewCompletion === true;
        return (
            <div className="h-full">
                <MyCandidaturesPage
                    type={type}
                    myCompletions={myCompletions}
                    canCreateANewCompletion={canCreate}
                />
            </div>
        );
    }

    // No applications started yet → Screen 1
    return (
        <div className="h-full">
            <WelcomeHomePage canCreateNewCompletion={type?.canCreateNewCompletion === true} />
        </div>
    );
}

export default withTranslation()(SectionHomePage);